<template>
  <b-nav-item-dropdown
    right
    @show="handleShowNotifications(false)"
  >
    <template v-slot:button-content>
      <span v-if="!userAvatar.src" class="avatar-initials">
        {{ userAvatar.initials }}
      </span>
      <img v-if="userAvatar.src"
        :alt="userAvatar.name"
        class="avatar-img"
        :src="userAvatar.src"
        style="">
    </template>
    <b-dropdown-item href="/#/user/profile">Meu perfil</b-dropdown-item>
    <b-dropdown-item href="/#/help/faq">Ajuda</b-dropdown-item>
    <b-dropdown-item @click="logout">Sair</b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import ProfileMixin from '@/modules/Application/mixins/ProfileMixin';
import { removeToken } from '@/configurations/token';

export default {
  name: 'NavbarConfigurations',
  props: ['handleShowNotifications'],
  mixins: [ProfileMixin],
  data() {
    return {
      userAvatar: {},
      img: 'https://compufour.s3.amazonaws.com/production/uploads/images',
    };
  },
  methods: {
    async logout() {
      await removeToken();
      window.location.href = '/#/login';
    },
  },
  async mounted() {
    await this.getProfile();
    this.userAvatar = await this.getAvatar();
  },
};
</script>

<style scoped>
  .avatar-img {
    border-radius: 50%;
    width: 37px;
  }
  .avatar-initials {
    background-color: #cacaca;
    border: 2px solid #4f4f4f;
    border-radius: 100%;
    color: #22262c;
    display: inline-block;
    font-weight: bolder;
    line-height: 34px;
    height: 37px;
    width: 37px;
    text-align: center;
    text-transform: uppercase;
    position: absolute;
  }
</style>
